"use client";

import React from "react";
import { QueryClientProvider, QueryClient } from "@tanstack/react-query";
// import { Auth0Provider } from "@auth0/auth0-react";
// import CONFIG from "../config/config";
import { SessionProvider } from "next-auth/react";
// const { auth } = CONFIG;
function Providers({ children }: React.PropsWithChildren) {
  const [client] = React.useState(new QueryClient());

  return (
    // <Auth0Provider
    //   domain={auth.domain}
    //   clientId={auth.clientId}
    //   // authorizationParams={{
    //   //   redirect_uri:
    //   //     typeof window !== "undefined" ? window.location.origin : "/",
    //   // }}
    // >
    <SessionProvider>
      <QueryClientProvider client={client}>{children}</QueryClientProvider>
    </SessionProvider>
    // </Auth0Provider>
  );
}

export default Providers;
